import React, { useContext, useState } from 'react';
import { Select, Slider, Typography } from 'antd';
import { CarOutlined } from '@ant-design/icons';
import SafetyCard from './SafetyCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;
const { Option } = Select;

const TowingServiceAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [serviceType, setServiceType] = useState('Mechanical failure');
  const [damageLevel, setDamageLevel] = useState('None');
  const [fuelLevel, setFuelLevel] = useState(50);
  const [loading, setLoading] = useState(false);

  const triggerTowingAlert = async () => {
    setLoading(true);
    const mockLocation = '40.7128°N, 74.0060°W';
    await triggerAlert(
      {
        serialNo,
        vehicleKey,
        actual: `Service: ${serviceType}, Damage: ${damageLevel}, Fuel: ${fuelLevel}%`,
        threshold: `Location: ${mockLocation}`,
      },
      credentials,
      ALERT_CATEGORY.TOWING_SERVICE_ALERT
    )
      .then(() => {
        messageApi.success(`Towing request sent - ${serviceType}`);
        onTriggered?.({
          success: true,
          value: `${serviceType} (${damageLevel}, ${fuelLevel}%)`,
        });
      })
      .catch(() => {
        messageApi.error('Failed to request towing service');
        onTriggered?.({ success: false, value: serviceType });
      })
      .finally(() => setLoading(false));
  };

  const damageLevelColor = {
    'None': '#16a34a',
    'Minor': '#f59e0b',
    'Moderate': '#ef9400',
    'Severe': '#ef4444',
  };

  return (
    <SafetyCard
      title="Towing Service"
      icon={<CarOutlined />}
      iconBg="#f5f3ff"
      iconColor="#7c3aed"
      protectionLevel="High"
      onTrigger={triggerTowingAlert}
      triggerLabel="Request Tow"
      loading={loading}
    >
      <div>
        <Text style={{ fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 6 }}>
          Service Type
        </Text>
        <Select value={serviceType} onChange={setServiceType} style={{ width: '100%' }}>
          <Option value="Mechanical failure">Mechanical Failure</Option>
          <Option value="Accident">Accident</Option>
          <Option value="Fuel empty">Fuel Empty</Option>
          <Option value="Other">Other</Option>
        </Select>
      </div>
      <div>
        <Text style={{ fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 6 }}>
          Damage Assessment
        </Text>
        <Select value={damageLevel} onChange={setDamageLevel} style={{ width: '100%' }}>
          <Option value="None">None</Option>
          <Option value="Minor">Minor Damage</Option>
          <Option value="Moderate">Moderate Damage</Option>
          <Option value="Severe">Severe Damage</Option>
        </Select>
      </div>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <Text style={{ fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            Fuel Level
          </Text>
          <Text style={{ fontSize: 12, fontWeight: 700, color: fuelLevel <= 20 ? '#ef4444' : '#0f172a' }}>
            {fuelLevel} %
          </Text>
        </div>
        <Slider min={0} max={100} value={fuelLevel} onChange={setFuelLevel} />
      </div>
      <div
        style={{
          padding: '10px 12px',
          borderRadius: 8,
          background: '#f5f3ff',
          border: '1px solid #ddd6fe',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#7c3aed', flexShrink: 0 }} />
        <Text style={{ fontSize: 11, color: '#6d28d9', fontWeight: 500 }}>
          Nearest service will be contacted with location
        </Text>
      </div>
    </SafetyCard>
  );
};

export default TowingServiceAlert;
